import { datadogRum } from '@datadog/browser-rum-slim';
import { useQuery } from '@tanstack/react-query';
import { getQueryKeyForStudio } from 'state/utils/getQueryKeyForStudio';
import { LocaleEnum } from 'schema/locale';
import { useLocale } from 'shared/hooks/useLocale';
import { Toasts } from 'types/studio/studio';
import { sanityFetch } from 'sanity-client';
import { ToastsDataServiceOptions } from './types';

export const query = `*[_type == "toasts" && language == $locale][0]`;

export async function toastsDataService({ locale = LocaleEnum.enUS }: ToastsDataServiceOptions) {
  try {
    const toastData = await sanityFetch<Toasts>(query, {
      locale
    });
    return toastData;
  } catch (err) {
    datadogRum.addError(err);
  }

  return null;
}

export function useQueryGetToastsData() {
  const locale = useLocale();
  return useQuery({
    queryKey: getQueryKeyForStudio({ keys: ['toasts', locale] }),
    queryFn: () => toastsDataService({ locale }),
    staleTime: Infinity
  });
}
